import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  Content: {
    width: '1024px',
    height: '600px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  Video: {
    display: 'block',
    maxWidth: '80%',
    width: '80%',
    maxHeight: '550px',
    height: 'auto'
  }
}));
